/**
 * Created by BFR on 06/12/2019.
 */
define('trackingDetailTabController',[
  'module',
  'underscore',
  'backbone',
  'app',
  'trackingDetailView',
  'settings'
], function(
  module,
  _,
  Backbone,
  App,
  View
) {
  'use strict';

  var TrackingDetailTabController = {
    showTab: function(data) {
      if (!data.tab) {
        data.tab = 'detail';
      }
      this.showTrackingInfo(data);
    },

      showTrackingInfo: function(data) {
      var that = this;
      this.model = data.model;
      this.tab = data.tab;
      this.data = data;
      that.createView();
    },

    createView: function() {
      var view;
      view = new View({
        model: this.model
      });
      view.tempModel = new Backbone.Model(this.model.toJSON());
      this.view = view;

      App.regions.getRegion('main').currentView.getRegion('content').currentView.getRegion('trackingDetailTab').show(view);
    }
  };

  module.exports = TrackingDetailTabController;
});
